// extracted by mini-css-extract-plugin
export default {"newServerContainer":"NewServer_newServerContainer__byDz2"};